<!-- -------- desktop header --------- -->
<div class="header d-none d-lg-block" [ngClass]="{ scrolled: isScrolled }" *ngIf="!isMobile">
  <div class="d-flex justify-content-between align-items-center w-100 menu-header">
    <div class="container bg-none">
      <div class="d-flex justify-content-between align-items-center w-100">
        <a class="cursor-pointer d-flex align-items-center p-0" routerLink="/{{ currentLanguage }}/" #navigation (click)="addActive($event, 'home')">
          <svg-icon src="/assets/images/svg-icons/logo.svg" [svgStyle]="{ 'width.px': '241', 'height.px': '55' }"></svg-icon>
        </a>

        <div class="menu-item d-flex align-items-center">
          <a class="navMenu" routerLink="/{{ currentLanguage }}" fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName)" title="{{ item.routeName }}" *ngFor="let item of navigations">{{ item.navName | translate }}</a>
          <a type="button" class="btn btn-secondary ms-2" routerLink="/{{ currentLanguage }}/staking" (click)="addActive($event, 'staking')" title="staking">{{ 'top_navigation.nav_staking' | translate }}</a>
          <a type="button" class="btn btn-secondary ms-2" href="/assets/documents/whitepaper.pdf" target="_blank" title="{{ 'misc.whitepaper' | translate }}">{{ 'misc.whitepaper' | translate }}</a>

          <!--- buynow wallet/address --->
          <div class="btn btn-primary ms-2" (click)="showWidget('home')" *ngIf="!walletAddress">{{ 'widget.buy_now' | translate }}</div>
          <div class="btn btn-primary ms-2" (click)="disconnect()" *ngIf="walletAddress">{{ walletAddress | trimAddress }}</div>

          <!---language dropdown-->

          <div class="btn-group language ms-2" dropdown>
            <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center">
              <!-- <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg" alt="" loading="lazy"> -->
              <div class="font-16 text-uppercase fw-semibold mx-1 font-mareks">{{ selectedLanguage.value }}</div>
              <!-- <svg-icon class="ms-2" src="./assets/images/svg-icons/angle-down.svg" [svgStyle]="{ 'width.px': '24', 'height.px': '12' }"></svg-icon> -->
            </div>

            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
              <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList" (click)="changeLanguage(lang.value)">
                <a href="/{{lang.value === 'en' ? '': lang.value}}" (click)="$event.preventDefault()" class="m-0 lang-link d-flex justify-content-center w-auto"  [ngClass]="{'active': selectedLanguage.value === lang.value}">
                  <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name" loading="lazy" />
                  <span class="text-white font-16">{{ lang.native_name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- -------- mobile header --------- -->

<div class="header d-block d-lg-none" [ngClass]="{ scrolled: isScrolled }" *ngIf="isMobile">
  <div class="d-flex justify-content-between align-items-center flex-grow-1 w-100">
    <div class="d-flex justify-content-start align-items-center">
      <a class="cursor-pointer p-0" routerLink="/{{ currentLanguage }}/" (click)="openCloseMenu()" #navigation>
        <svg-icon src="/assets/images/svg-icons/logo.svg" [svgStyle]="{ 'width.px': '180', 'height.px': '49' }"></svg-icon>
      </a>
    </div>

    <div class="menu-btn" (click)="openCloseMenu()">
      <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-burger' : 'burger-icon' }}.svg" [svgStyle]="{ 'width.px': 50, 'height.px': 50 }"></svg-icon>
    </div>
  </div>

  <div class="menu-overlay" *ngIf="showMenu">
    <div class="sub-menu pull-left" [ngClass]="{ open: openMenu }">
      <!--- menu links-->
      <div class="d-flex flex-column justify-content-start align-items-start w-100">
        <!-- <a class="navMenu" routerLink="/{{ currentLanguage }}/staking" title="staking" (click)="openCloseMenu()" routerLinkActive="active">
          {{ 'top_navigation.nav_staking' | translate }}
        </a> -->
        <a class="navMenu" *ngFor="let item of navigations" routerLink="/{{ currentLanguage }}" fragment="{{ item.routeName }}" 
          (click)="addActive($event, item.routeName); openCloseMenu()" title="{{ item.routeName }}">{{ item.navName | translate }}
        </a>
      </div>

      <!--- social links --->

      <span class="social-wrap d-flex align-items-center justify-content-start gap-3 mt-3">
        <a *ngFor="let item of social" href="{{ item.link }}" target="_blank">
          <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
        </a>
      </span>
      
      <div class="d-flex align-items-center justify-content-start gap-3 my-3">
        <a type="button" class="btn btn-secondary fs-6" routerLink="/{{ currentLanguage }}/staking" (click)="addActive($event, 'staking')" title="staking">{{ 'top_navigation.nav_staking' | translate }}</a>
        <a type="button" class="btn btn-secondary fs-6" href="/assets/documents/whitepaper.pdf" target="_blank" title="{{ 'misc.whitepaper' | translate }}">{{ 'misc.whitepaper' | translate }}</a>
      </div>

      <!---language dropdown-->
      <div class="btn-group language mb-3" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center justify-content-between">
          <div>
            <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg" [alt]="selectedLanguage.value" loading="lazy">
            <span class="ms-1 font-16 text-uppercase fw-semi-bold ms-2">{{ selectedLanguage.value }}</span>
          </div>

          <svg-icon class="dropdown" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '20', 'height.px': '20' }"></svg-icon>
        </div>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
           <li class="p-2 cursor-pointer justify-content-start align-items-center" role="menuitem" *ngFor="let lang of languagesList"
            (click)="changeLanguage(lang.value)">
            <a href="/{{lang.value === 'en' ? '': lang.value}}" (click)="$event.preventDefault()" class="m-0 pb-1 lang-link d-flex justify-content-center"  [ngClass]="{'active': selectedLanguage.value === lang.value}">
              <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="flag-icon" loading="lazy" />
              <span class="text-white font-16">{{ lang.native_name }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="btn btn-secondary mx-auto" (click)="showWidget('home'); openCloseMenu()" *ngIf="!walletAddress">{{ 'widget.buy_now' | translate }}</div>
      <div class="btn btn-secondary mx-auto" (click)="disconnect(); openCloseMenu()" *ngIf="walletAddress">{{ walletAddress | trimAddress }}</div>
    </div>
  </div>
</div>
